import { useMemo } from 'react';

import useHeaderView from 'v2/resources/hooks/services/headerView/useHeaderView';
import { useAppSelector } from 'v2/resources/hooks/useAppSelector';

const useHome = () => {
  const { dashboardLoading, nurserySelected } = useAppSelector(
    (state) => state.dashboard
  );
  const { selectedCycle } = useAppSelector((state) => state.selectedCycle);
  const { nurseries } = useAppSelector((state) => state.nurseries);
  const { cycles } = useAppSelector((state) => state.cycles);
  const { nameProperty } = useAppSelector((state) => state.nameProperty);

  const { data: dataDashboard, isLoading: loadingDashboard } =
    useHeaderView(nameProperty);

  const getMainSurvivalText = (selectedCycle: any) => {
    const survivalText = 'Sobrevivência';

    if (!selectedCycle) {
      return survivalText;
    }

    const isCycleCompleted = selectedCycle.start && selectedCycle.end;
    const estimatedText = `${survivalText} Estimada`;
    const totalText = `${survivalText} Total`;

    return isCycleCompleted ? totalText : estimatedText;
  };

  const mainSurvivalText = useMemo(
    () => getMainSurvivalText(selectedCycle),
    [selectedCycle]
  );

  return {
    dashboardLoading,
    nurserySelected,
    nurseries,
    cycles,
    mainSurvivalText,
    loading: loadingDashboard,
    cost: dataDashboard?.consumption ?? 0,
    fca: dataDashboard?.fca ?? 0,
    harvestBiomass: dataDashboard?.biomass ?? 0,
    survival: dataDashboard?.survival_total ?? 0,
  };
};

export default useHome;
